import React from "react";
import { useAgeGate } from "@/contexts/AgeGateContext";
import { useLang } from "@/contexts/LangContext";
import { ShieldCheck, X } from "lucide-react";

export default function AgeGate() {
  const { confirmed, confirm } = useAgeGate();
  const { t } = useLang();

  if (confirmed) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 backdrop-blur-xl px-4"
      data-testid="age-gate-overlay"
    >
      <div className="relative max-w-lg w-full bg-[#0c0c0c] border border-white/10 rounded-lg p-8 sm:p-10 shadow-[0_0_80px_rgba(212,175,55,0.08)]">
        <div className="flex items-center gap-3 mb-6">
          <ShieldCheck className="w-6 h-6 text-gold" strokeWidth={1.5} />
          <span className="text-overline">Relaxora</span>
        </div>
        <h2 className="font-heading text-3xl sm:text-4xl font-light text-white mb-4 tracking-tight">
          {t.age_gate.title}
        </h2>
        <p className="text-[#a3a3a3] leading-relaxed mb-6 text-sm sm:text-base">{t.age_gate.body}</p>
        <div className="gold-divider mb-6" />
        <p className="text-xs text-[#737373] italic mb-8">{t.age_gate.policy}</p>
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={confirm}
            className="btn-gold rounded-md px-6 py-3 flex-1 text-sm tracking-wide"
            data-testid="age-gate-confirm"
          >
            {t.age_gate.confirm}
          </button>
          <a
            href="https://www.google.com"
            className="btn-ghost-dark rounded-md px-6 py-3 text-center text-sm tracking-wide flex items-center justify-center gap-2"
            data-testid="age-gate-deny"
          >
            <X className="w-4 h-4" strokeWidth={1.5} />
            {t.age_gate.deny}
          </a>
        </div>
      </div>
    </div>
  );
}
